let print_base = "/api/print/",
  admin_base = "/api/admin/";
export default {
  login: admin_base + "login", //登录接口
  logout: admin_base + "logout", //登出接口
  getOrderList: print_base + "order/list", //订单列表
  getOrderByUid: print_base + "order/getByUid", //通过uid获取订单
  batchShip: print_base + "order/batch/ship", //导入发货
  exportOrder: print_base + "order/export", //导出订单
  sendCM: print_base + "cm/admin/send", //发送消息
  uploadFile: print_base + "file/upload", //上传图片
  queryFaqList: print_base + "faq/list", //问题列表
  createOrUpdateFaq: print_base + "faq/save", //新增或修改问题
  deleteFaq: print_base + "faq/delete", //删除问题
  saveFaqDesc: print_base + "faq/desc/save", //开头语句
};
